import Input from 'components/Form/Input'
import { TotalTimeDiv } from 'modules/Drives/ViewDriveRole/BulkActionDrawer/ReleaseOfferDrawer/Components/RoleDetails/style'
import { FormItem } from 'modules/Drives/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/style'
import React from 'react'

const RoleDetails = ({rolesMetrics}) => {
  
  return (
    <>
      <FormItem>
        <TotalTimeDiv>Role</TotalTimeDiv>
        <Input
          width="100%"
          placeholder="Role"
          value={rolesMetrics[0]?.roleName}
          disabled={true}
        />
      </FormItem>
      <FormItem>
        <TotalTimeDiv>Designation *</TotalTimeDiv>
        <Input
          width="100%"
          placeholder="Designation"
          name={'designation'}
          rules={[
            {
              required: true,
              message: 'Please enter designation!',
            },
          ]}
        />
      </FormItem>
      <FormItem>
        <TotalTimeDiv>Job Location *</TotalTimeDiv>
        <Input
           width="100%"
           placeholder="Chennai"
           name={'jobLocation'}
           rules={[
          {
            required: true,
            message: 'Please enter job location!',
          },
        ]}
          />
      </FormItem>
    </>
  )
}

export default RoleDetails
